var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.3425,
    cy: 53.6576,
    r: 53.3425,
    fill: "#102437"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3646 30.217C46.2709 29.3484 49.4779 28.7805 53.019 28.7805C69.0207 28.7805 81.9823 41.7422 81.9823 57.7439C81.9823 73.7455 69.0207 86.7072 53.019 86.7072C37.0173 86.7072 24.0557 73.7455 24.0557 57.7439C24.0557 51.7975 25.8596 46.2521 28.933 41.642",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2227 31.0187L48.8771 19.9277",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2227 31.0188L50.4806 39.2368",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/RotateLeft.936f97f53c2956e0a3c9ce7f647adc62.svg";
export { ForwardRef as ReactComponent };